"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3619],{

/***/ 73619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_OurApproach; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
;// CONCATENATED MODULE: ./components/sections/OurApproach/ourApproach.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 3rem;\n    padding-right: 3rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 6.5rem;\n    padding-right: 6.5rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 7.5rem;\n    padding-right: 7.5rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    margin: 5rem 0 3rem 0;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 7.5rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 19.75rem;\n    margin-right: 1.85rem;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 23rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}



const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "ezocd9p0"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";");
const Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezocd9p1"
})(mixins/* defaultContainerSize */.sX, ";display:flex;flex-direction:column;justify-content:space-between;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", {
    target: "ezocd9p2"
})("font-family:var(--font-base);font-style:normal;font-weight:normal;font-size:2rem;line-height:3.5rem;letter-spacing:-0.013rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";margin:4rem 0 2rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";");
const Approaches = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezocd9p3"
})("display:flex;flex-direction:row;flex-wrap:wrap;");
const Approach = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezocd9p4"
})("width:100%;margin-bottom:5.5rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";");
const ApproachText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezocd9p5"
})("position:relative;font-family:var(--font-base);font-style:normal;font-weight:normal;font-size:1.5rem;line-height:1.75rem;letter-spacing:-0.013rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";padding-bottom:0.625rem;margin-bottom:0.625rem;&:after{background:linear-gradient(89.99deg,#0e4ed7 -15.08%,#f94743 93.47%);transition:opacity 200ms ease-in-out;content:'';height:2px;width:100%;position:absolute;bottom:0;left:0;}");
const ApproachDescription = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezocd9p6"
})("font-family:var(--font-second);font-size:1rem;font-style:normal;font-weight:300;line-height:2rem;letter-spacing:0.013rem;text-align:left;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.darker_grey;
}, ";");

;// CONCATENATED MODULE: ./components/sections/OurApproach/OurApproach.tsx




const OurApproach = (param)=>{
    let { title , approaches , titleAs  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                    as: titleAs,
                    children: title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Approaches, {
                    children: approaches.map((param, index)=>{
                        let { title , description  } = param;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Approach, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ApproachText, {
                                    children: prismic_reactjs.RichText.asText(title)
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ApproachDescription, {
                                    children: prismic_reactjs.RichText.asText(description)
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/OurApproach/index.ts

/* harmony default export */ var sections_OurApproach = (OurApproach);


/***/ })

}]);